import React, { Component } from "react";
import Input from "../levty-ui/input";

import { hasAllKeysTrue } from "../../utils/objects";
import LoadingButton from "../levty-ui/loadingButton";
import { setCarrersAuthentication, getCarrersAuthentication, removeCarrersAuthentication } from "../../utils/authentication";
import contactService from "../../services/contactService";

class CarrerDataModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputs: {
        validations: {
          name: false,
          email: false
        },
        values: this.handleInputsValue()

      },
      allInputsValid: false
    }

  }

  setInputData = (input, validation, value) => {
    const { inputs } = this.state;
    inputs.validations[input] = validation;
    inputs.values[input] = value;

    this.setState({ inputs });
    this.validateForm();
  }

  validateForm() {
    const { inputs } = this.state;
    this.setState({ allInputsValid: hasAllKeysTrue(inputs.validations) });
  }

  handleSubmit = async (event) => {

    event.preventDefault();
    try {
      // se ja esta logado faz o logout neste momento
      removeCarrersAuthentication();

      let { inputs } = this.state;

      inputs.values.contactReason = "application";

      this.setState({ isLoading: true });

      if (await contactService.sendMessageStartSite(inputs.values)) {
        
        this.setState({ isLoading: false });
        this.props.handleEmailTokenModal(true);

        setCarrersAuthentication({
          name: inputs.values.name,
          email: inputs.values.email,
          accessToken: ""
        });

      } else {
        removeCarrersAuthentication();
      }
    } catch {
      removeCarrersAuthentication();
    }
  }

  handleClose = () => {
    const { handleClose } = this.props;
    handleClose();
  }

  handleInputsValue = () => {
    // const inputValues = getCarrersAuthentication();
    // if (inputValues) {
    //   return inputValues;
    // } else {
      return {
        name: "",
        email: ""
      }
    // }
  }

  handleAllInputsValid() {
    return getCarrersAuthentication() ? true : false;
  }

  handleGoogleAuth() {
    window.location.href = process.env.REACT_APP_LOGIN_API + "googleAuthenticator?one_redirect=" + window.location.href.split('?')[0];
  }

  handleFacebookAuth() {
    window.location.href = process.env.REACT_APP_LOGIN_API + "facebookAuthenticator?one_redirect=" + window.location.href.split('?')[0];
  }

  handleLinkedInAuth() {
    window.location.href = process.env.REACT_APP_LOGIN_API + "linkedinAuthenticator?one_redirect=" + window.location.href.split('?')[0];
  }

  render() {
    const { allInputsValid, isLoading, inputs } = this.state;
    return (
      <>
        <div translate="no" className="notranslate modal fade show animated fadeInDown fast" id="levDadosAcesso" style={this.props.abs ? { "display": "block", "position": "absolute" } : { "display": "block" }}>
          <div translate="no" className="notranslate modal-dialog" role="document">
            <div translate="no" className="notranslate modal-content">
              <div translate="no" className="notranslate modal-header text-center align-items-center flex-column p-0">
                <h5 className="h2 modal-title" id="exampleModalLabel">Cadastre-se</h5>
                <p translate="no" className="notranslate mb-4 pb-2">Conecte-se para acessar nossas vagas.</p>
                <button type="button" className="close" onClick={this.handleClose}>
                  <span className="notranslate" translate="no" aria-hidden="true">&times;</span>
                </button>
                <div translate="no" className="notranslate row social-connections">
                  <button id="submit-login-form-linkedin" aria-label="Continuar com LinkedIn" className="col btn linkedin-login btn-social" onClick={this.handleLinkedInAuth}>
                    <img className="" src="/images/icons/logo-linkedin.svg" alt="" />
                  </button>
                  <button id="submit-login-form-google" aria-label="Continuar com Google" className="col btn google-login btn-social" onClick={this.handleGoogleAuth}>
                    <img className="" src="/images/icons/logo-google.svg" alt="" />
                  </button>
                  {/* <button id="submit-login-form-facebook" aria-label="Continuar com Facebook" className="col btn facebook-login btn-social" onClick={this.handleFacebookAuth}>
                    <img className="" src="/images/icons/logo-facebook.svg" alt="" />
                  </button> */}
                </div>
                <p translate="no" className="notranslate m-4 pb-2">Ou utilize seu nome e e-mail.</p>
              </div>

              <div translate="no" className="notranslate modal-body">
                <form id="carrer-data" onSubmit={this.handleSubmit}>
                  <div translate="no" className="notranslate mb-4 form-group">
                    <Input
                      id="name"
                      label="Nome completo"
                      type="text"
                      aditionalClass="form-control-lg"
                      required={true}
                      readOnly={false}
                      callBackFunction={this.setInputData}
                      value={inputs.values.name}
                      requiredErrorMessage={!this.handleAllInputsValid() ? "" : "Confira os dados informados"}
                    />
                  </div>
                  <div translate="no" className="notranslate mb-4 form-group">
                    <Input
                      id="email"
                      label="E-mail"
                      type="email"
                      aditionalClass="form-control-lg"
                      required={true}
                      readOnly={false}
                      callBackFunction={this.setInputData}
                      value={inputs.values.email}
                      validationErrorMessage={"E-mail inválido"}
                      requiredErrorMessage={!this.handleAllInputsValid() ? "" : "Confira os dados informados"}
                    />
                  </div>
                  <LoadingButton
                    label="Continuar"
                    aditionalClass="primary mb-3"
                    onlyDisable={!allInputsValid}
                    isLoading={isLoading}
                    type="submit"
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
        <div translate="no" className="notranslate modal-backdrop fade show"></div>
      </>
    )
  }
}
export default CarrerDataModal;
